import { render, staticRenderFns } from "./HaberlerListe.vue?vue&type=template&id=50239bcb&scoped=true&"
import script from "./HaberlerListe.vue?vue&type=script&lang=js&"
export * from "./HaberlerListe.vue?vue&type=script&lang=js&"
import style0 from "./HaberlerListe.vue?vue&type=style&index=0&id=50239bcb&lang=scss&scoped=true&"
import style1 from "./HaberlerListe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50239bcb",
  null
  
)

export default component.exports